module.exports = __webpack_public_path__ + "static/service5-2bc7d6548a35f0b6123226a3fe4a2b56.png";